import { useTranslation } from 'react-i18next'
import CopyButton from '../components/CopyButton';
import NextSectionCard from '../components/NextSectionCard';
import { timeSince } from '../utils/timeSince';
import PreviousSectionCard from '../components/PreviousSectionCard';
import caseIcon from "../assets/icons/case.svg";
import { Trans } from "react-i18next";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import step2 from "../assets/image/excel/step2.png";
import step4 from "../assets/image/excel/step4.png";
import step7 from "../assets/image/excel/step7.png";
import step8 from "../assets/image/excel/step8.png";
import step9 from "../assets/image/excel/step9.png";
import step10 from "../assets/image/excel/step10.png";
import step11a from "../assets/image/excel/step11a.png";
import step11b from "../assets/image/excel/step11b.png";
import step12a from "../assets/image/excel/step12a.png";
import step12b from "../assets/image/excel/step12b.png";

const Excel = () => {
    const { t, i18n } = useTranslation();
    const lastUpdated = "2026-03-19";
    const lang = i18n.language;

    const buildCopyText = (t) => {
        return [
            `${t("excel.step1")}`,
            `   - ${t("excel.step1a")}`,
            `   - ${t("excel.step1b")}`,

            `${t("excel.step2")}`,
            `${t("excel.step3")}`,
            `${t("excel.step4")}`,
            `${t("excel.step5")}`,
            `${t("excel.step6")}`,
            `${t("excel.step7")}`,
            `${t("excel.step8")}`,

            `${t("excel.step9")}`,
            `   - ${t("excel.step9a")}`,
            `   - ${t("excel.step9b")}`,
            `   - ${t("excel.step9c")}`,
            `   - ${t("excel.step9d")}`,
            `   - ${t("excel.step9e")}`,
            `   - ${t("excel.step9f")}`,

            `${t("excel.step10")}`,
            `   - ${t("excel.step10a")}`,

            `${t("excel.step11")}`,

            `${t("excel.step12")}`,
            `${t("excel.step12des")}`,
            `   - ${t("excel.step12a")}`,
            `   - ${t("excel.step12b")}`,
            `   - ${t("excel.step12c")}`,
            `   - ${t("excel.step12d")}`,
        ].join("\n");
    };
    return (
        <div className="text-black dark:text-white">
            <div
                className="
          desktop:px-4
          py-3
          max-w-3xl
        "
            >
                <div className="relative flex items-center justify-between gap-3">
                    <div className="flex items-center gap-1">
                        <div>
                            <img src={caseIcon} alt="case" className="w-6 h-6" />
                        </div>
                        <div>
                            <p className="text-[16px] tabletpro:text-[12px] mini_mobile:text-[14px] text-[#0087FE] font-normal">
                                {t("sidebar.cases.title").toUpperCase()}
                            </p>
                        </div>
                    </div>

                    <CopyButton text={buildCopyText(t)} />
                </div>

                <div className="mt-2 relative">
                    <section className='flex gap-4'>
                        <p className='text-[#020617] dark:text-[#F8FAFC] text-[40px] tabletpro:text-[22px] mobile:text-[30px] mini_mobile:text-[24px] font-semibold'>{t("sidebar.cases.excel")}</p>
                    </section>

                    <section className='flex flex-col gap-4 mt-1'>
                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="excel.step1"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <ul className="list-disc pl-6 space-y-1">
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                {t("excel.step1a")}
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                {t("excel.step1b")}
                            </li>
                        </ul>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="excel.step2"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step2

                        }}>
                            <img
                                src={step2}
                                alt="step2"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="excel.step3"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="excel.step4"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step4

                        }}>
                            <img
                                src={step4}
                                alt="step4"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="excel.step5"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="excel.step6"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="excel.step7"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step7

                        }}>
                            <img
                                src={step7}
                                alt="step7"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="excel.step8"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step8

                        }}>
                            <img
                                src={step8}
                                alt="step8"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="excel.step9"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <ul className="list-disc pl-6 space-y-1">
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="excel.step9a"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="excel.step9b"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="excel.step9c"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="list-none text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="excel.step9d"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="excel.step9e"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="excel.step9f"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                        </ul>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step9

                        }}>
                            <img
                                src={step9}
                                alt="step9"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="excel.step10"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <ul className="list-disc pl-6 space-y-1">
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="excel.step10a"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                        </ul>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step10

                        }}>
                            <img
                                src={step10}
                                alt="step10"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="excel.step11"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step11a

                        }}>
                            <img
                                src={step11a}
                                alt="step11a"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step11b

                        }}>
                            <img
                                src={step11b}
                                alt="step11b"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="excel.step12"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="excel.step12des"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <ul className="list-disc pl-6 space-y-1">
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="excel.step12a"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="excel.step12b"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="excel.step12c"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="excel.step12d"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                        </ul>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step12a

                        }}>
                            <img
                                src={step12a}
                                alt="step12a"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>
                        <Zoom zoomMargin={80} zoomImg={{
                            src: step12b

                        }}>
                            <img
                                src={step12b}
                                alt="step12b"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>
                    </section>

                    <section className='flex gap-4 mt-4 flex-col desktop:flex-row'>
                        <PreviousSectionCard
                            label={t("sidebar.cases.word")}
                            to="/cases/word"
                        />
                        <NextSectionCard
                            label={t("sidebar.cases.powerPoint")}
                            to="/cases/powerpoint"
                        />
                    </section>

                    {/* Last updated */}
                    <section className='flex gap-4 mt-4'>
                        <span className="text-[14px] text-[#64748B]">
                            {t("welcome.lastUpdatedBase")} {timeSince(lastUpdated, lang)}
                        </span>
                    </section>
                </div>

            </div>
        </div>

    )
}

export default Excel
